import { render, staticRenderFns } from "./Extra-cookie-acceptance-banner.vue?vue&type=template&id=e49ba28c&"
import script from "./Extra-cookie-acceptance-banner.vue?vue&type=script&lang=js&"
export * from "./Extra-cookie-acceptance-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports